module.exports = __webpack_public_path__ + "static/media/hero-sticker.b92f45a5.svg";